import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, User, Check, ChevronUp } from "lucide-react";
import { Button } from "@shared/components/ui/button";

const Experiences = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(true);
  
  const handleContinue = () => {
    navigate("/payment");
  };

  const handleBack = () => {
    navigate("/personalize");
  };

  return (
    <div className="relative min-h-screen flex flex-col items-center p-0 lg:p-4 overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center z-0" 
        style={{ 
          backgroundImage: "url('/lovable-uploads/4576ba33-075c-44e7-9241-e25722b719fe.png')",
          backgroundPosition: "center 40%"
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
      </div>

      <div className="relative z-10 animate-fade-in max-w-md w-full bg-card shadow-none rounded-b-2xl lg:shadow-lg lg:rounded-2xl overflow-visible lg:overflow-hidden">
        <header className="booking-header px-6">
          <div className="w-10 flex justify-start">
            <button className="text-brand">EN</button>
          </div>
          <div className="text-center">
            <img
              src="/lovable-uploads/102e9d96-45b2-444b-9858-6df793a16955.png"
              alt="Don Julio"
              className="h-16 mx-auto"
            />
            <div className="text-brand-light text-sm tracking-widest uppercase">PARRILLA</div>
          </div>
          <div className="w-10 flex justify-end">
            <button className="text-brand">
              <User size={20} />
            </button>
          </div>
        </header>

        {/* Reservation Info */}
        <div className="w-full pt-3 pb-3 flex justify-center gap-2 flex-wrap">
          <div className="selector-button text-sm font-medium">
            2 PEOPLE
          </div>
          <div className="selector-button text-sm font-medium">
            WED 2, APR
          </div>
          <div className="selector-button text-sm font-medium">
            11:30
          </div>
        </div>

        <div className="booking-content pt-6 pb-16 flex flex-col items-center">
          <h1 className="text-2xl font-display mb-8 text-center">Book your experience</h1>
          
          <div className="w-full rounded-xl border border-border overflow-hidden bg-card mb-12 shadow-card">
            <div 
              className="p-4 flex justify-between items-center cursor-pointer border-b border-border"
              onClick={() => setExpanded(!expanded)}
            >
              <div className="flex items-center">
                <div className="w-6 h-6 rounded bg-brand text-brand-foreground flex items-center justify-center mr-3">
                  <Check size={14} />
                </div>
                <h3 className="text-lg font-medium">Sidewalk (OUTDOORS)</h3>
              </div>
              <ChevronUp 
                className={`text-foreground/40 transition-transform ${expanded ? "" : "transform rotate-180"}`} 
                size={20} 
              />
            </div>
            
            {expanded && (
              <div className="p-4 space-y-4">
                <p className="text-foreground/70">
                  You are selecting a sidewalk table (OUTDOORS) with awning, blankets and semi heated.
                </p>
                
                <p className="text-foreground/70">
                  We can only assign a table in the interior room if there is availability at the time of your arrival.
                </p>
                
                <div className="flex items-center mt-2">
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    className="text-foreground/70 mr-2"
                  >
                    <path d="M19 9V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v2"></path>
                    <path d="M1 9h22"></path>
                    <path d="M3 9v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9"></path>
                    <path d="M10 13h4"></path>
                  </svg>
                  <span className="text-foreground/70">ARS - per person</span>
                </div>
              </div>
            )}
          </div>

          <div className="w-full flex justify-between">
            <button
              className="w-14 h-14 rounded-full border border-brand text-brand flex items-center justify-center"
              onClick={handleBack}
            >
              <ChevronLeft size={24} />
            </button>
            
            <Button 
              className="btn-primary w-36"
              onClick={handleContinue}
            >
              CONTINUE
            </Button>
          </div>
        </div>

        {/* Progress indicator */}
        <div className="step-indicator">
          <div className="step-progress" style={{ width: "95%" }}></div>
        </div>

        {/* Footer logo */}
        <div className="absolute bottom-6 w-full text-center text-xs text-foreground/50">
          <span className="text-foreground/40">powered by </span>
          <span className="font-semibold tracking-widest">MEITRE</span>
          <div className="mt-1">
            <a href="#" className="text-xs underline">Privacy policy</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experiences;
